import React, { useState } from "react";
import { Table, Tooltip } from "antd";
import { TbRestore } from "react-icons/tb";
import { MdDelete } from "react-icons/md";
import dayjs from "dayjs";
import ModalPopup from "../Common/Modal/Modal";
import BinDelete from "./BinDelete";
import BinRestore from "./BinRestore";
import {
  TiArrowUnsorted,
  TiArrowSortedUp,
  TiArrowSortedDown,
} from "react-icons/ti";
import { capitalizeFirstLetter,capitalizeEachWord } from "../Common/Captilization";
import ReactPaginate from "react-js-pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";


export default function Promotion({selectedTab}) {
  const apiUrl = process.env.REACT_APP_API_URL;

  const [tbsId, setTbsId] = useState();
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [restoreModalOpen, SetRestoreModalOpen] = useState(false);
  const [sortOrderPromoTitle, setSortOrderPromoTitle] = useState(null);
  const [sortDescriptionTitle, setDescriptionTitle] = useState(null);
  const [sortOrderPromoDate, setSortOrderPromoDate] = useState(null);
  const [rowName, SetRowName] = useState();
    const [sortedData, setSortedData] = useState();
    const [sortOrderOpName, setSortOrderOpName] = useState(null);
  const crud=sessionStorage.getItem("crud_permission")
     const getBin = useSelector((state) => state.crm.bin_data);
       const [activePage, setActivePage] = useState(1);
       const itemsPerPage = selectedTab === 3 ? 5 : selectedTab === 4 ? 5 : 10;
     
       const indexOfLastItem = activePage * itemsPerPage;
       const indexOfFirstItem = indexOfLastItem - itemsPerPage;
       const currentItems = sortedData?.length > 0
        ? sortedData.slice(indexOfFirstItem, indexOfLastItem): getBin.slice(indexOfFirstItem, indexOfLastItem)
       // Handle page change
       const handlePageChange = (pageNumber) => {
         setActivePage(pageNumber);
       };

  const closeDeleteModal = () => {
    setDeleteModalOpen(false);
    SetRestoreModalOpen(false);
  };
    const handleOpNameSort = () => {
    let sorted = [...getBin];
    if (sortOrderOpName === "ascend") {
      sorted.sort((a, b) =>{ 
      const opA=a.deleted_data?.operator_details||"";
      const opB=b.deleted_data?.operator_details||"";
      return opB.localeCompare(opA);
      }
      );
      setSortOrderOpName("descend");
    } else if (sortOrderOpName === "descend") {
      sorted = [...getBin]; // Reset to original order
      setSortOrderOpName(null);
    } else {
      sorted.sort((a, b) =>
      {
        const opA=a.deleted_data?.operator_details||"";
        const opB=b.deleted_data?.operator_details||"";
        return opB.localeCompare(opA);
      }
      );
      setSortOrderOpName("ascend");
    }
    setSortedData(sorted);
  };

  
  const handlePromoTitleSort = () => {
    let sorted = [...getBin];
    if (sortOrderPromoTitle === "ascend") {
      sorted.sort((a, b) => {
      const nameA = a.deleted_data.promo_name || "";
      const nameB = b.deleted_data.promo_name || "";
      return nameB.localeCompare(nameA)});
      setSortOrderPromoTitle("descend");
    } else if (sortOrderPromoTitle === "descend") {
      sorted = [...getBin]; // Reset to original order
      setSortOrderPromoTitle(null);
    } else {
      sorted.sort((a, b) => {
       const nameA = a.deleted_data.promo_name || "";
      const nameB = b.deleted_data.promo_name || "";
      return nameA.localeCompare(nameB);
    });
      setSortOrderPromoTitle("ascend");
    }
    setSortedData(sorted);
  };

  const handleDescSort = () => {
    let sorted = [...getBin];
    if (sortDescriptionTitle === "ascend") {
      sorted.sort((a, b) => {
      const nameA = a.deleted_data.promo_description || "";
      const nameB = b.deleted_data.promo_description || "";
      return nameB.localeCompare(nameA)});
      setDescriptionTitle("descend");
    } else if (sortDescriptionTitle === "descend") {
      sorted = [...getBin]; // Reset to original order
      setDescriptionTitle(null);
    } else {
      sorted.sort((a, b) => {
       const nameA = a.deleted_data.promo_description || "";
      const nameB = b.deleted_data.promo_description || "";
      return nameA.localeCompare(nameB);
    });
      setDescriptionTitle("ascend");
    }
    setSortedData(sorted);
  };

    const handlePromoDateSort = () => {
      let sorted = [...getBin]
      if (sortOrderPromoDate === "ascend") {
        sorted.sort(
          (a, b) =>
            dayjs(b.deleted_date).valueOf() - dayjs(a.deleted_date).valueOf()
        );
        setSortOrderPromoDate("descend");
      } else if (sortOrderPromoDate === "descend") {
        sorted = [...getBin]
        setSortOrderPromoDate(null);
      } else {
        sorted.sort(
          (a, b) =>
            dayjs(a.deleted_date).valueOf() - dayjs(b.deleted_date).valueOf()
        );
        setSortOrderPromoDate("ascend");
      }
      setSortedData(sorted);
    };

  const columns = [
    {
      title: (
        <div className="flex font-bold justify-center text-[1.1vw]">S.No</div>
      ),
      width: "4vw",
      render: (row, rowdta, index) => {
        const pageNo = (activePage - 1) * itemsPerPage + index + 1
        return (
          <div className="flex justify-center">
            <h1 className="pl-[.5vw] text-[1vw] text-[#1F4B7F]">{pageNo}</h1>
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold justify-center flex items-center">
          Name
          <button onClick={handlePromoTitleSort} className="">
                                          {sortOrderPromoTitle === "ascend" ? (
                                            <Tooltip
                                              placement="top"
                                              title="Ascending"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowSortedUp />
                                            </Tooltip>
                                          ) : sortOrderPromoTitle === "descend" ? (
                                            <Tooltip
                                              placement="top"
                                              title="Descending"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowSortedDown />
                                            </Tooltip>
                                          ) : sortOrderPromoTitle === null ? (
                                            <Tooltip
                                              placement="top"
                                              title="Unsorted"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowUnsorted />
                                            </Tooltip>
                                          ) : (
                                            <Tooltip
                                              placement="top"
                                              title="Ascending"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowSortedUp />
                                            </Tooltip>
                                          )}
                                        </button>
        </h1>
      ),
     
      render: (row, rowdta, index) => {
        const promoName = row?.deleted_data?.promo_name;
    
        // Apply capitalization and slicing logic
        const displayName = promoName?.charAt(0) === promoName?.charAt(0)?.toLowerCase()
          ? capitalizeEachWord(promoName?.slice(0, 18))
          : promoName?.slice(0, 18);
    
        return (
          <div className="flex items-center pl-[1.2vw] text-[#1F4B7F] font-bold text-[1vw]">
            {promoName?.length > 18 ? (
              <Tooltip
                placement="bottom"
                title={promoName}
                className="cursor-pointer"
                color="#1F487C"
              >
                <span>{`${displayName}...`}</span>
              </Tooltip>
            ) : (
              <span>{displayName}</span>
            )}
          </div>
        );
      },
      width: "11vw",
    },    
    {
      title: (
        <h1 className="text-[1.1vw] font-bold justify-center  flex items-center ">
          Operator Name
          <button onClick={handleOpNameSort} className="">
                                          {sortOrderOpName === "ascend" ? (
                                            <Tooltip
                                              placement="top"
                                              title="Ascending"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowSortedUp />
                                            </Tooltip>
                                          ) : sortOrderOpName === "descend" ? (
                                            <Tooltip
                                              placement="top"
                                              title="Descending"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowSortedDown />
                                            </Tooltip>
                                          ) : sortOrderOpName === null ? (
                                            <Tooltip
                                              placement="top"
                                              title="Unsorted"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowUnsorted />
                                            </Tooltip>
                                          ) : (
                                            <Tooltip
                                              placement="top"
                                              title="Ascending"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowSortedUp />
                                            </Tooltip>
                                          )}
                                        </button>
        </h1>
      ),
      width: "14vw",
      render: (row, rowdta, index) => {
        return (
          <div className="flex items-center pl-[1.5vw] ">
            <p className="text-[1vw] font-bold text-[#1F4B7F] ">{row.deleted_data.operator_details}</p>
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold justify-center flex items-center">
          Description
          <button onClick={handleDescSort} className="">
                                          {sortDescriptionTitle === "ascend" ? (
                                            <Tooltip
                                              placement="top"
                                              title="Ascending"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowSortedUp />
                                            </Tooltip>
                                          ) : sortDescriptionTitle === "descend" ? (
                                            <Tooltip
                                              placement="top"
                                              title="Descending"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowSortedDown />
                                            </Tooltip>
                                          ) : sortDescriptionTitle === null ? (
                                            <Tooltip
                                              placement="top"
                                              title="Unsorted"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowUnsorted />
                                            </Tooltip>
                                          ) : (
                                            <Tooltip
                                              placement="top"
                                              title="Ascending"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowSortedUp />
                                            </Tooltip>
                                          )}
                                        </button>
        </h1>
      ),
      render: (row, rowdta, index) => {
        return (
          <div className="flex items-center pl-[1vw] ">
            <h1 className="text-[1vw] text-[#1F4B7F] ">
              {row?.deleted_data?.promo_description?.length > 27 ? (
                <Tooltip
                  placement="bottom"
                  title={row?.deleted_data.promo_description}
                  className="cursor-pointer"
                  color="#1F487C"
                >
                  {`${row?.deleted_data.promo_description?.slice(0, 27)}...`}
                </Tooltip>
              ) : (
                row?.deleted_data.promo_description?.slice(0, 27)
              )}
            </h1>
          </div>
        );
      },
      width: "18vw",
    },

    {
      title: (
        <div className="flex font-bold justify-center text-[1.1vw]">
          Duration
        </div>
      ),
      width: "11vw",
      render: (row) => {
        return (
          <div>
            <p className="text-[1vw] justify-center text-[#1F4B7F] flex ">{`${dayjs(
              row?.deleted_data.start_date
            ).format("MMM DD")} - ${dayjs(row?.expiry_date).format(
              "MMM DD"
            )}`}</p>
          </div>
        );
      },
    },
    {
      title: (
        <div className="flex justify-center font-bold text-[1.1vw]">Usage</div>
      ),
      width: "7vw",
      render: (row) => {
        return (
          <div>
            <p className="text-[1vw] pl-[1.5vw]  text-[#1F4B7F] ">{row?.deleted_data.usage}</p>
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold justify-center flex items-center">
          Deleted Date
          <button onClick={handlePromoDateSort} className="">
                                          {sortOrderPromoDate === "ascend" ? (
                                            <Tooltip
                                              placement="top"
                                              title="Ascending"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowSortedUp />
                                            </Tooltip>
                                          ) : sortOrderPromoDate === "descend" ? (
                                            <Tooltip
                                              placement="top"
                                              title="Descending"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowSortedDown />
                                            </Tooltip>
                                          ) : sortOrderPromoDate === null ? (
                                            <Tooltip
                                              placement="top"
                                              title="Unsorted"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowUnsorted />
                                            </Tooltip>
                                          ) : (
                                            <Tooltip
                                              placement="top"
                                              title="Ascending"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowSortedUp />
                                            </Tooltip>
                                          )}
                                        </button>
        </h1>
      ),
      width: "13vw",
      render: (row) => {
        return (
          <div className="flex items-center justify-center">
            <p className="text-[1vw] text-[#1F4B7F] ">{`${dayjs(row?.deleted_date).format(
              "DD MMM, YY"
            )}`}</p>
          </div>
        );
      },
    },
    {
      title: (
        <div className="flex  font-bold justify-center text-[1.1vw]">Status</div>
      ),
      width: "10vw",
      render: (row) => {
        return (
          <div className="flex justify-center  ">
            <button
              className={`${row?.deleted_data?.promo_status_id == 0
                  ? "bg-[#646262]"
                  : row.deleted_data?.promo_status_id == 1
                    ? "bg-[#FF9900]"
                    : row.deleted_data?.promo_status_id == 2
                      ? "bg-[#34AE2B]"
                      : row.deleted_data?.promo_status_id == 3
                        ? "bg-[#2A99FF]"
                        : row.deleted_data?.promo_status_id == 4
                          ? "bg-[#FD3434]"
                          : "bg-[#646262]"
                } h-[1.8vw] shadow-md shadow-black font-extrabold text-[1vw] text-white w-[7vw] cursor-not-allowed rounded-[0.5vw]`}
            >
              {row?.deleted_data.promo_status}
            </button>
          </div>
        );
      },
    },
    {
      title: (
        <div className="flex justify-center  font-bold text-[1.2vw]">
          Actions
        </div>
      ),
      width: "10vw",
      render: (row) => {
        console.log(row, "rowrowrowrow");
        return (
          <div className="flex justify-center">
            <div className="flex gap-[0.7vw]   items-center">
              <span>
                <TbRestore
                  size={"1.3vw"}
                 className={`${crud?.includes("view")||crud?.includes("create")||crud?.includes("delete")?"cursor-not-allowed":"cursor-pointer"}`}
                  color="#1F4B7F"
                  onClick={() => {
                     if(!crud?.includes("view") && !crud?.includes("delete") && !crud?.includes("create")){
                    SetRestoreModalOpen(true);
                    setTbsId(row?.tbs_recycle_id);
                    SetRowName(row?.deleted_data.promo_name);
                  }}}
                />
              </span>
              <span>
                <MdDelete
                  size={"1.3vw"}
                  color="#1F4B7F"
                  className={`${crud?.includes("view")||crud?.includes("create")||crud?.includes("update")?"cursor-not-allowed":"cursor-pointer"}`}
                  onClick={() => {
                     if(!crud?.includes("view") && !crud?.includes("update") && !crud?.includes("create")){
                    setDeleteModalOpen(true);
                    setTbsId(row?.tbs_recycle_id);
                    SetRowName(row?.deleted_data.promo_name);
                  }}}
                />
              </span>
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="h-[72vh] w-full">
        <Table
          dataSource={currentItems}
          columns={columns}
          pagination={false}
          className="custom-table"
        />
      </div>
      <div>
        {getBin?.length > 10 ? (
            <div className="w-full h-[8vh] flex justify-between items-center ">
              <div className="text-[#1f4b7f] flex text-[1.1vw] gap-[0.5vw]">
                <span>Showing</span>
                <span className="font-bold">
                  {currentItems && currentItems?.length > 0 ? (
                    <div>
                      {indexOfFirstItem + 1} -{" "}
                      {indexOfFirstItem + currentItems?.length}
                    </div>
                  ) : (
                    "0"
                  )}
                </span>
                <span>from</span>
                <span className="font-bold">
                  {getBin?.length > 0 ? getBin?.length : 0}
                </span>
                <span>data</span>
              </div>
              <div>
                <ReactPaginate
                  activePage={activePage}
                  itemsCountPerPage={itemsPerPage}
                  totalItemsCount={getBin?.length}
                  pageRangeDisplayed={3}
                  onChange={handlePageChange}
                  itemClass="page-item"
                  linkClass="page-link"
                  activeClass="active"
                  prevPageText={
                    <FontAwesomeIcon icon={faChevronLeft} size="1vw" />
                  }
                  nextPageText={
                    <FontAwesomeIcon icon={faChevronRight} size="1vw" />
                  }
                  firstPageText={
                    <FontAwesomeIcon icon={faAngleDoubleLeft} size="1vw" />
                  }
                  lastPageText={
                    <FontAwesomeIcon icon={faAngleDoubleRight} size="1vw" />
                  }
                />
              </div>
            </div>
          ) : (
            ""
          )}
      </div>
      <ModalPopup
        show={deleteModalOpen}
        onClose={closeDeleteModal}
        height="21vw"
        width="30vw"
        closeicon={false}
      >
        <BinDelete
          setDeleteModalOpen={setDeleteModalOpen}
          deleteid={tbsId}
          // title={`want to delete ( ${rowName} ) offer Permenantly`}
          title={
            <>
              Want to delete <span style={{ fontWeight: 'bold' }}>{capitalizeEachWord(rowName)}</span> permanently ?
            </>
          }
          id={tbsId}
          tab={selectedTab}
        />
      </ModalPopup>
      <ModalPopup
        show={restoreModalOpen}
        onClose={closeDeleteModal}
        height="21vw"
        width="30vw"
        closeicon={false}
      >
        <BinRestore
          SetRestoreModalOpen={SetRestoreModalOpen}
          url={`${apiUrl}/restore-promotions/${tbsId}`}
          // title={`want to restore ( ${rowName} ) offer`}
          title={
            <>
              Want to restore <span style={{ fontWeight: 'bold' }}>{capitalizeEachWord(rowName)}</span> promotion ?
            </>
          }
          id={tbsId}
          tab={selectedTab}
        />
      </ModalPopup>
    </>
  );
}
